import * as React from 'react'
import type { CountdownRenderProps } from 'react-countdown'
import { default as ReactCountdown } from 'react-countdown'
import { tw } from 'utils/classnames'
import { useIsMounted } from 'hooks/use-is-mounted'

export interface DateFormatProps {
  day: string
  hour: string
  minute: string
  second: string
}
export interface CountdownProps {
  className?: string
  date: Date | string | number
  prefix?: string
  isEmphasized?: boolean
  style?: React.CSSProperties
  separator?: string
  onComplete?: VoidFunction
  dateFormat?: DateFormatProps
  isBoxed?: boolean
  daysInMinutes?: boolean
}

export const Countdown = (props: CountdownProps) => {
  const {
    isBoxed,
    className,
    prefix,
    isEmphasized,
    style,
    separator = ' ',
    dateFormat = { day: 'd', hour: 'h', minute: 'm', second: 's' },
    daysInMinutes = false,
    ...countdownProps
  } = props
  const isMounted = useIsMounted()

  const renderCountdown = ({ days, hours, minutes, seconds }: CountdownRenderProps) => {
    const daysValue = isMounted ? days : 0
    const hoursValue = isMounted ? hours : 0
    const minutesValue = isMounted ? minutes : 0
    const secondsValue = isMounted ? seconds : 0

    const countdownData = [
      {
        format: dateFormat.day,
        time: daysValue,
      },
      {
        format: dateFormat.hour,
        time: hoursValue,
      },
      {
        format: dateFormat.minute,
        time: minutesValue,
      },
      {
        format: dateFormat.second,
        time: secondsValue,
      },
    ]

    if (isBoxed) {
      return (
        <div>
          {prefix ? <h4 className="flex font-bold uppercase">{prefix} </h4> : null}
          <div className="flex gap-[6px]">
            {countdownData.map((date, idx) => (
              <div
                className="border-primary-500 flex h-[85px] w-[25%] flex-col items-center justify-center rounded border"
                key={idx}
              >
                <span className="text-primary-500 text-3xl font-bold">{date.time}</span>
                <span className="text-primary-500 text-sm">{`${date.format}${separator}`}</span>
              </div>
            ))}
          </div>
        </div>
      )
    }

    return (
      <p
        className={tw(isEmphasized && 'text-cf-red-600', 'text-xs capitalize', className)}
        style={style}
      >
        {prefix ? `${prefix} ` : null}
        {daysInMinutes
          ? `${minutesValue}${dateFormat.minute}${separator}${secondsValue}${dateFormat.second}`
          : `${daysValue}${dateFormat.day}${separator}${hoursValue}${dateFormat.hour}${separator}${minutesValue}${dateFormat.minute}${separator}${secondsValue}${dateFormat.second}`}
      </p>
    )
  }

  return <ReactCountdown renderer={renderCountdown} {...countdownProps} />
}
